import {Senses} from '../enums';

type Sense = {
	type: keyof typeof Senses;
	value: string;
	note?: string;
};

/** в глоссарий ведут только виды зрения: пассивное Внимание — это значение, а не термин */
export function toMonsterSenses(passive: number, senses?: Sense[] | null) {
	const result = (senses || []).map((sense) => {
		const title = Senses[sense.type];
		let text = `{@term ${sense.type}, ${title}} ${sense.value}`;
		if (sense.note) text += ` (${sense.note})`;
		return text;
	});

	result.push(`пассивное Внимание ${passive}`);

	return result.join('; ');
}
